export default __webpack_public_path__ + "static/media/tokamak-network.6c10b6c5.jpg";